import { pxToRem, spacing5 } from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const CartActionsWrapper = styled.div`
  display: flex;
  margin-top: ${pxToRem(70)};
  gap: ${spacing5};
`;
